export default "__VITE_ASSET__BkQk95D9__"